module.exports = __webpack_public_path__ + "static/media/4-th.3a32f6b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/4-th.wav
// module id = cYMe
// module chunks = 1